<template>
  <div class="main_center" style="margin: 0 0;padding-top: 8px;">

    <div class="content">

      <el-form ref="form" :model="form" label-width="150px">

        <el-row>
          <el-col :span="6">
            <!-- <el-form-item label="年份：">
              <el-select v-model="form.year" value-key="value" style="width:100%;" @change="yearsChange">
                <el-option v-for="(item, index) in yearsList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item> -->

            <!-- 从年份更改为固定的1 近一年、3 近三年、5 近五年 -->
            <el-form-item label="年份：">
              <el-select v-model="form.year" value-key="value" style="width:100%;" @change="yearsChange">
                <el-option v-for="(item, index) in newyearsList" :key="index" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>


          </el-col>

          <el-col :span="6">
            <el-form-item label="关键字搜索：" props="searchKey">
              <el-input v-model="form.searchKey" clearable placeholder="请输入关键字搜索"
                @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="7" :offset="1" >
            <el-form-item label="编号：" props="businessCode">
              <el-input v-model="form.businessCode" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1" v-if="moreSearchItem">
            <el-form-item label="名称：" props="businessName">
              <el-input v-model="form.businessName" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6" v-if="moreSearchItem">
            <el-form-item label="交易中心：">
              <el-select v-model="form.tradeId" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item, index) in transactionCenterList" :key="index" :label="item.orgName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="formColumns.length > 0 && moreSearchItem">
            <!-- :offset="index % 3 == 1 ? 1 : 0" -->
            <el-col :span="6" v-for="(item, index) in formColumns" :key="index">
              <el-form-item :label="`${item.label}：`" :prop="item.value">
                <el-input v-if="item.datasourceType == 0" v-model="form[item.value]" clearable
                  :placeholder="`请输入${item.label}`"></el-input>
                <el-cascader style="width: 100%;" v-if="item.datasourceType == 1" v-model="form[item.value]"
                  :props="item.props"></el-cascader>

                <el-select v-if="item.datasourceType == 2" v-model="form[item.value]" clearable style="width:100%;">
                  <el-option v-for="(_item) in item.options" :key="_item.value" :label="_item.label"
                    :value="_item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="6">
            <el-form-item label="">
              <div class="searchbutton">
                <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                 <el-button size="small" type="primary" @click="seachBtn">搜索</el-button>
<!--                <el-button size="small" type="primary" @click="getTableColumns">搜索</el-button>-->




                
                <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true">|
                  展开</el-button>
                <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false">|
                  收起</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <space :left="-16" :right="-16" :bottom="16" />


      <div v-show="columns.length === 0" class="empty">
        <span class="empty_text">暂无数据</span>
      </div>


      <div v-show="columns.length != 0">
        <el-table :data="tableData" v-loading="dataListLoading" ref="multipleTable" :height="tableMaxHeight" stripe
          border @selection-change="handleSelectionChange">
          <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
            :show-overflow-tooltip='true'></el-table-column>
          <el-table-column label="操作" fixed="right" align="left" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" title="查看" @click="router(scope.row)">{{ scope.row.witnessStatus ==
        '1' ? '见证' : '查看' }}</el-button>
            </template>
          </el-table-column>

          <el-table-column v-for="(col, idx) in columns" :fixed="idx < 2" :key="col.id" :label="col.columnLabel"
            :prop='col.columnName' header-align="left" align="left" 
            :min-width="col.columnWidth ? (col.columnWidth.slice(0, -2) | 0) + 45 + 'px' : '200px'"
            :show-overflow-tooltip='true'>

            <!-- 
              原获取的宽度有的很窄 导致表格高度扩大出现滚动条，所以新方法都加长一点
              :min-width="(col.columnWidth.slice(0, -2) | 0) + 25 + 'px'"
              :min-width='col.columnWidth'
             -->

            
          </el-table-column>
        </el-table>
         <!-- <el-pagination background
                     layout="sizes, prev, pager, next, total"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination> -->
      <pagination class="limit" :page-sizes="[10, 20, 50, 100]" :total="total" :page.sync="pageIndex"
        :limit.sync="pageSize" @pagination="paginationChange">
      </pagination>


      </div>



     
    </div>
  </div>
</template>

<script>
import { nearSixYearsList } from '@/utils/index';
import space from '../../common/components/space.vue';
import Pagination from '@/components/Pagination.vue';
let id = 0
export default {
  name: "businessNodes",
  components: {
    space,
    Pagination
  },

  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 300,
      dataListLoading: false,
      yearsList: [],
      form: {
        // year: new Date().getFullYear(),
        year: 1,
        businessCode: "",
        businessName: "",
        tradeId: '', // 交易中心ID
        searchKey: '',
      },

      newyearsList: [
        {
          value: 1,
          label: '近一年'
        }, {
          value: 3,
          label: '近三年'
        }, {
          value: 5,
          label: '近五年'
        },
      ],

      fromCode: '',
      formId: '',
      moreSearchItem: false,
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      columns: [],
      detailId: '',
      multipleSelection: [],
      user: '', //角色类型
      transactionCenterList: [],
      formColumns: [],
    }
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },

  },
  activated() {
    this.getFromCodesFromUrl()
    if (!this.formId || this.formId == '0') {
      this.getTableColumns();
    }





  },
  created() {
    this.getFromCodesFromUrl()
    this.yearsList = nearSixYearsList(this.form.year);
    this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
  },
  mounted() {
    this.getDataList()
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  computed: {

  },

  methods: {

    getFromCodesFromUrl() {
      let url = this.$route.path;
      let arr = url.split('/');
      const len = arr.length;
      let formCode = arr[len - 1];
      this.fromCode = formCode;
    },

    ifmove() {

      let hasBtnPermisson = this.hasBtnPermission('btn_jz_buswitness_' + this.businessType + 'del');
      let tableMaxHeight = document.documentElement.clientHeight - 328 + (hasBtnPermisson ? 0 : 41);
      this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      // this.getDataList()
  
    },
    yearsChange(val) {
      this.yearsList = nearSixYearsList(val)
      this.getDataList()  //获取表格数据
    },
    getTableColumns() {
      if (!this.fromCode) {
        return
      }
      this.$http({
        url: this.$http.adornUrl('/customform/query/list_field/' + this.fromCode),
        method: "post",
        baseURL: '',
      }).then(res => {
        var data = res.data
        this.detailId = data.detailId || "";
        this.formId = data.formId || "0";
        this.columns = data.columns || [];
        console.log(this.columns,'看一下columns是多少');
        // data.columns.forEach(item => {
        //   item.isQueryParam = true
        // })
        this.generateFormColumns(data.columns)
        this.getDataList()
      })
    },
    async generateFormColumns(columns) {
      const formColumns = []
      // datasourceType 0 是input类型 1是cascade级联类型 2 select类型
      if (columns) {
        columns.forEach(async (item) => {
        if (item.isQueryParam) {
          if (item.datasourceType == 0) {
            formColumns.push({
              label: item.columnLabel,
              value: item.columnName,
              datasourceType: item.datasourceType,
            })
            // 把字段key存到form中
            this.$set(this.form, item.columnName, '')
          } else if (item.datasourceType == 1) {
            formColumns.push({
              label: item.columnLabel,
              value: item.columnName,
              datasourceType: item.datasourceType,
              props: {
                lazy: true,
                lazyLoad: (node, resolve) => {
                  const { level, data = {} } = node;
                  this.$http.post('/suite/loadRegions', { parentId: data.parentCode || item.datasource }).then(res => {
                    const nodes = res.data.map(item => ({
                      value: item.regionCode,
                      label: item.regionName,
                      leaf: item.hasChild == false,
                      parentCode: item.parentCode
                    }));
                    resolve(nodes);
                    // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                  })
                },
              },
            })
            this.$set(this.form, item.columnName, [])
          } else {
            this.$http.get('/sys/dictData/getList?type=' + item.datasource).then(res => {
              if (res.data.code == 1) {
                const list = res.data.data || []
                const options = list.map(v => {
                  return {
                    label: v.name,
                    value: v.value
                  }
                })
                formColumns.push({
                  label: item.columnLabel,
                  value: item.columnName,
                  datasourceType: item.datasourceType,
                  options: options,
                })
              }

            })
            // const options = await this.$http.get('/customform/query/list_field/' + item.datasource)
            this.$set(this.form, item.columnName, '')
          }

        }
      })
      this.formColumns = formColumns
      }
     
    },
    formatParams(params) {
      const formatParams = {}
      for (const key in params) {
        if (params[key] !== '') {
          formatParams[key] = params[key]
        }
        // 如果是数组， 则取最后一个值
        if (Array.isArray(params[key])) {
          formatParams[key] = params[key][params[key].length - 1]
        }
      }
      return formatParams
    },
    getDataList() { // 获取列表数据
      this.dataListLoading = true;
      const formatParams = this.formatParams(this.form)
      if (!this.formId) {
        return
      }
      this.$http({
        url: this.$http.adornUrl('/customform/query/list/' + this.formId),
        method: "post",
        data: {
          'page': this.pageIndex,
          'rows': this.pageSize,
          // 'filter': this.form
          searchKey: this.form.searchKey,
          'filter': {
            ...formatParams,
            tradeId: this.form.tradeId,
          }
        },
        baseURL: '',
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading = false;
      }).catch(e => {
        console.error("请求错误：", e)
        this.dataListLoading = false;
      })
    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()

    },
    paginationChange(obj) {
      this.pageIndex = obj.page || 1
      this.pageSize = obj.limit || 5
      this.getDataList();
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //搜索按钮
    seachBtn() {
      this.pageIndex = 1;
      this.getDataList()
    },
    reflash() {//刷新按钮
      this.pageIndex = 1;
      this.$refs['form'].resetFields();
      this.form.businessName = "";
      this.form.businessCode = "";
      this.form.year = new Date().getFullYear();
      this.yearsList = nearSixYearsList(this.form.year);
      this.form.tradeId = '';
      this.getDataList()

    },


    router(item) { // 跳转详情
      var id = item.id;
      //window.sessionStorage.setItem("id", id);
      //  window.sessionStorage.setItem("addUpdateIndex",1)

      this.$router.push({
        name: 'businessnodes_detail',
        query: {
          formid: this.formId,
          id: id
        },
        meta: { title: "业务详情" }
      })

    },

  },

  destroyed() {
    window.onresize = null;
  },




}
</script>
<style lang="less" scoped>
//列表页面
.main_center {
  .top {
    .seachbtn {
      margin-left: 100px;
      display: flex;
    }
  }

  // 搜索按钮区
  .searchbutton {
    // 调整分辨率放大下的文字按钮换行
    display: inline-flex;
  }

  // 无数据文字
  .empty {
    width: 100%;
    height: 200px;
    margin: 0 auto;
    text-align: center;
    line-height: 200px;

    .empty_text {
      font-size: 16px;
      color: #5e6d82;
      line-height: 1.5em;
    }
  }

}
</style>
